import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './video-section.css';

function VideoSection({
    src,
    poster,
    autoPlay = true,
    loop = true,
    muted = true
}) {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    const [isMuted, setIsMuted] = useState(muted);

    const togglePlay = () => {
        const v = videoRef.current;
        if (!v) return;
        if (v.paused) {
            v.play();
            setIsPlaying(true);
        } else {
            v.pause();
            setIsPlaying(false);
        }
    };

    const toggleMute = () => {
        const v = videoRef.current;
        if (!v) return;
        v.muted = !v.muted;
        setIsMuted(v.muted);
    };

    return (
        <section className="dt-video-section">
            {/* Decorative graphics */}
            <div className="dt-video-grid-bg" aria-hidden="true"></div>
            <div className="dt-video-glow dt-video-glow-1" aria-hidden="true"></div>
            <div className="dt-video-glow dt-video-glow-2" aria-hidden="true"></div>
            <div className="dt-video-shape dt-video-shape-1" aria-hidden="true"></div>
            <div className="dt-video-shape dt-video-shape-2" aria-hidden="true"></div>
            <div className="dt-video-shape dt-video-shape-3" aria-hidden="true"></div>

            <div className="dt-video-container">
                <div className="dt-video-wrapper">
                    {src ? (
                        <video
                            ref={videoRef}
                            className="dt-video"
                            src={src}
                            poster={poster}
                            autoPlay={autoPlay}
                            loop={loop}
                            muted={muted}
                            playsInline
                        />
                    ) : (
                        <div className="dt-video-placeholder">
                            <div className="dt-video-placeholder-icon">▶</div>
                            <p>Add your video source here</p>
                        </div>
                    )}

                    {/* Controls */}
                    {src && (
                        <div className="dt-video-controls">
                            <button
                                className="dt-video-btn"
                                onClick={togglePlay}
                                aria-label={isPlaying ? 'Pause' : 'Play'}
                            >
                                {isPlaying ? '❚❚' : '▶'}
                            </button>
                            <button
                                className="dt-video-btn"
                                onClick={toggleMute}
                                aria-label={isMuted ? 'Unmute' : 'Mute'}
                            >
                                {isMuted ? '🔇' : '🔊'}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Bottom fade to blend with next section */}
            <div className="dt-video-fade" aria-hidden="true"></div>
        </section>
    );
}

VideoSection.propTypes = {
    src: PropTypes.string,
    poster: PropTypes.string,
    autoPlay: PropTypes.bool,
    loop: PropTypes.bool,
    muted: PropTypes.bool
};

export default VideoSection;
